module.exports = __WEBPACK_EXTERNAL_MODULE_simplebar_vue__;